import React, { Component, Fragment } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { toggleToaster } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import InputNumber from '@/components/InputNumber'
import IconComponent from '@/components/commons/IconComponent'
import RadioButton from '../../RadioButton/index'

class VideoUrl extends Component {
  state = {
    src: {
      image: '',
      platform: '',
      video: ''
    },
    time: {
      enabled: false,
      start: 0,
      end: 0,
    },
    noControls: false,
    autoplay: false,
    loop: false,
  }

  componentDidMount() {
    const { src, options: { time, noControls, autoplay, loop } } = this.props
    this.setState({ src, time, noControls, autoplay, loop })
  }

  componentWillUnmount() {
    const { onChangeOptions } = this.props
    const { time, noControls, autoplay, loop } = this.state

    onChangeOptions({
      time,
      noControls,
      autoplay,
      loop
    })
  }

  handleURL = async (value) => {
    const { translation, toggleToaster } = this.props

    const youtubeRegex = /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/
    const vimeoRegex = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i
    const wistiaRegex = /https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/(.*)/

    if (youtubeRegex.test(value)) {
      return this.handleYoutube(value)
    }

    if (vimeoRegex.test(value)) {
      return this.handleVimeo(value)
    }

    if (value.match(wistiaRegex)) {
      return this.handleWistia(value)
    }

    return toggleToaster({
      isVisible: true,
      message: translation('video-url-warning'),
      position: 'top-right',
      type: 'error'
    })
  }

  handleYoutube = url => {
    const { onChangeSrc } = this.props

    const youtubeID = url
      .match(/(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/)
      .pop()

    this.setState({
      src: {
        platform: 'youtube',
        image: `https://img.youtube.com/vi/${youtubeID}/mqdefault.jpg`,
        video: `https://www.youtube.com/embed/${youtubeID}`
      }
    }, () => onChangeSrc(this.state.src))

  }

  handleVimeo = async url => {
    const { translation, toggleToaster, onChangeSrc } = this.props

    try {
      const { data } = await axios.get(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`)

      this.setState({
        src: {
          platform: 'vimeo',
          image: data.thumbnail_url,
          video: `https://player.vimeo.com/video/${data.video_id}`
        }
      }, () => onChangeSrc(this.state.src))
    } catch (error) {
      toggleToaster({
        isVisible: true,
        message: translation('video-vimeo-url-warning'),
        position: 'top-right',
        type: 'error'
      })
    }
  }

  handleWistia = async url => {
    const { translation, toggleToaster, onChangeSrc } = this.props

    try {
      const wistiaID = url
        .match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/(.*)/)
        .pop()

      const { data } = await axios.get(`https://fast.wistia.net/oembed?url=${encodeURIComponent(url)}`)

      this.setState({
        src: {
          platform: 'wistia',
          image: data.thumbnail_url,
          video: `https://fast.wistia.net/embed/iframe/${wistiaID}`
        }
      }, () => onChangeSrc(this.state.src))

    } catch (error) {
      toggleToaster({
        isVisible: true,
        message: translation('video-wistia-url-warning'),
        position: 'top-right',
        type: 'error'
      })
    }
  }

  handleVideoTime = enabled => this.setState(prevState => ({
    time: { ...prevState.time, enabled }
  }))

  handleTimeStart = start => this.setState(prevState => ({
    time: {
      ...prevState.time,
      start
    }
  }))

  handleTimeEnd = end => this.setState(prevState => ({
    time: {
      ...prevState.time,
      end
    }
  }))

  render() {
    const { src, time, noControls, loop } = this.state
    const { translation } = this.props


    return (
      <Fragment>
        <div className={''}>
          <input
            className='ba-input ba-w-100' type='text'
            placeholder="https://www.youtube.com/watch?v=hy4GxajnoFc"
            value={src.video}
            onChange={({ target }) => this.handleURL(target.value)}
          />
          <div className={'ba-gp-06 ' + styles['wrapper-video-url__platforms']}>
            <IconComponent icon="vimeo" />
            <IconComponent icon="youtube" />
            <IconComponent icon="wistia" />
          </div>
        </div>
        <div className={'ba-mg-t-1 ' + styles['wrapper-video-url__options']}>
          <span className='ba-font'>{translation('video-time')}</span>

          <hr className="ba-hr" />

          <div className={'ba-flex ba-gp-2'}>
            <InputNumber
              className='ba-input ba-w-100' type='number'
              placeholder="Start" unit='min'
              disabled={src.platform === 'vimeo' || src.platform === 'wistia' || loop}
              value={+time.start}
              onChange={({ target }) => this.handleTimeStart(+target.value)}
            />
            <InputNumber
              className='ba-input ba-w-100' type='number'
              placeholder="End" unit='sec'
              disabled={src.platform === 'vimeo' || src.platform === 'wistia' || loop}
              value={+time.end}
              onChange={({ target }) => this.handleTimeEnd(+target.value)}
            />
          </div>

          <div>
            <div className="ba-flex ba-ai-center ba-mg-t-1">
              <RadioButton
                id='video-controls' name='video-controls' checked={noControls}
                onClick={() => this.setState({ noControls: !noControls })} />
              <label htmlFor='video-controls' className={'ba-bold ba-mg-l-1 ' + (noControls ? 'ba-color-blue1' : '')}>
                {translation('video-no-controls')}
              </label>
            </div>

            <div className="ba-flex ba-ai-center ba-mg-t-1">
              <RadioButton
                id='loop' name='loop' checked={loop}
                onClick={() => this.setState({ loop: !loop })} />
              <label htmlFor='loop' className={'ba-bold ba-mg-l-1 ' + (loop ? 'ba-color-blue1' : '')}>
                {translation('video-loop')}
              </label>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)

  return { translation }
}


export default connect(
  mapStateToProps,
  { toggleToaster }
)(VideoUrl)



// WEBPACK FOOTER //
// ./src/components/editors/VideoUrl/index.js